
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { SalesforceMarketingCloudLinkedService } from 'app/model/linkedservice/salesforce-marketing-cloud.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: 'SalesforceMarketingCloudObject',
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.SalesforceMarketingCloud_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.SalesforceMarketingCloud_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: SalesforceMarketingCloudLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SalesforceMarketingCloudObjectDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
